export const scheduleStatus = state => state.scheduleStatus;
export const scheduleStatusLoadInProgress = state =>
  state.scheduleStatus === null;



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/selectors/schedule-status.js